export default __webpack_public_path__ + "static/media/entertainment.763e61a0.svg";